import styled from 'styled-components';

export const LinkButton = styled.button<{ color?: string; isFluid?: boolean }>`
  color: ${({ theme, color }) => color || theme.colors.linkColor};
  display: inline;
  outline: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }

  text-overflow: ellipsis;
  width: ${({ isFluid }) => (isFluid ? '100%' : 'auto')};
`;

export default LinkButton;
